
import { getMasterCustomLabels, saveCustomLabelValues } from '../actions/UserActions';
import _ from 'lodash';
import { CommonButton } from '../../../../src/components/buttons';
import { connect } from 'react-redux';
import React from 'react';
import TextField from 'material-ui/TextField';
class CustomFields extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      staffID: '',
      customDataFields: [],
    };
    this.handleSave = this.handleSave.bind(this);
    this.handleSaveContinue = this.handleSaveContinue.bind(this);
  };
  componentWillMount() {
    this.props.getMasterCustomLabels(this.props.staffId);
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.saved_customLabelValues && nextProps.saved_customLabelValues !== this.props.saved_customLabelValues) {
      // this.props.getMasterCustomLabels(this.props.staffId);
    }

    if (nextProps.masterCustomLabels && nextProps.masterCustomLabels !== this.props.masterCustomLabels) {
      let masterCustomLabels = nextProps.masterCustomLabels.data.MasterCustomLabels || [];
      let customLabelValues = nextProps.masterCustomLabels.data.StaffCustomLabels || [];
      let dataFields = [];
      masterCustomLabels.forEach((obj, index) => {
        let customLabelValueObj = customLabelValues.find((customObj) => customObj.customLabelID === obj.id);
        dataFields.push({
          ...customLabelValueObj,
          'staffID': this.props.staffId,
          'customLabelID': obj.id,
          'customLabelName': obj.customLabelName,
          customLabelValue: (customLabelValueObj && customLabelValueObj.customLabelValue) || '',
        });
      });
      this.setState({
        customDataFields: dataFields,
      });
    }
  };

  fieldOnChange(index, value) {
    let dataFields = this.state.customDataFields;
    if (!dataFields[index]) {
      dataFields.push({ customLabelValue: null });
      _.update(dataFields, `[${index}].customLabelValue`, function(n) {
        return value;
      });
    } else {
      _.update(dataFields, `[${index}].customLabelValue`, function(n) {
        return value;
      });
    }
    this.setState({
      customDataFields: dataFields,
    });
  }

  handleSaveContinue() {
    this.handleSave();
    this.props.handleUserTabChange('2');
  }

  handleSave= () => {
    let formData = (this.state.customDataFields || []);

    // if (!formData.length) {
    //   return false;
    // }
    // console.log(JSON.stringify(formData));
    this.props.saveCustomLabelValues(formData);
  };

  renderCustomFields() {
    const customDataFields = this.state.customDataFields || [];

    if (!customDataFields.length) {
      return (
        <div className="col-sm-12 history_card">
          <div className="familydl text-center no-record">
            No record found.
          </div>
        </div>
      );
    }
    return customDataFields.map((field, index) => {
      return (
        <div key={index} className="col-md-4">
          <TextField
            id= {index.toString()}
            name= {index.toString()}
            floatingLabelText={field.customLabelName}
            fullWidth={true}
            className="valuefont"
            autoComplete={'off'}
            floatingLabelStyle={{ color: '#7a7a7a' }}
            value={field.customLabelValue || ''}
            onChange={(e) => this.fieldOnChange(index, e.target.value)}
          />
        </div>
      );
    });
  };

  render() {
    return (
      <div>
        <form className="readmin-form custom_form" noValidate onSubmit={(e) => {
          e.preventDefault();
          this.handleSave();
        } }>

          <div className="row">
            {this.renderCustomFields()}
          </div>
          <div className="row">
            <div className="col-sm-12 pt20 btn_rt">
              {this.props.loading ?
                <CommonButton primary={true} className="loader_btn" disabled = {true } label= "Saving"/> : <CommonButton type="submit" primary={true} label= "Save"/>}
              <CommonButton className="ml_15" primary={true} label ="Save & Continue" onTouchTap={() =>
                this.handleSaveContinue()
              }/>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    masterCustomLabels: state.user.masterCustomLabelStaff,
    saved_customLabelValues: state.patient.saved_customLabelValues,
    loading: state.user.loading,
  };
};

export default connect(mapStateToProps, { saveCustomLabelValues, getMasterCustomLabels })(CustomFields);



// WEBPACK FOOTER //
// ./src/modules/users/User/CustomFields.js